import { createContext } from 'react';
import { WizardContextValue } from './wizard.model';

export const WizardContext = createContext<WizardContextValue | null>(null);
